<div class="spinner">
    <div class="dot"></div>
    <span class="text">Loading</span>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>